import { graphql, useStaticQuery } from 'gatsby'
import ContentType from '../enums/ContentType'
import RoutingEnum from '../routes/appRoutes'
import appRoute from '../routes/appRoutes'
import LocalesLocationEnum from '../enums/LocalesLocationEnum'
import LocalesRequestEnum from '../enums/LocalesRequestEnum'
import { LocalesProductsEnum } from '../enums/LocalesProductEnum'

const PathQuery = graphql`
  query PathQuery {
    allSitePage {
      edges {
        node {
          path
        }
      }
    }
  }
`

export const slugify = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const slugifyFromNode = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/[%!?"*]+/g, '')
    .replace(/[\s_',/-]+/g, '-')
    .replace(/^-+|-+$/g, '')

class UrlFactory {
  constructor(paths) {
    if (paths) {
      this.paths = paths
    } else {
      this.paths = useStaticQuery(PathQuery).allSitePage.edges.map(
        (item) => item.node.path,
      )
    }
  }

  static getBasicPageUrl(basicPageSlug) {
    if (basicPageSlug) return `/${basicPageSlug}`
    return '/'
  }

  static getNewsUrl(newsSlug) {
    if (newsSlug) return `/news/${newsSlug}`
    return '/news'
  }

  static getStoriesUrl(slug) {
    if (slug) return `/about-us/stories/${slug}`
    return '/about-us/stories'
  }

  static addHttps(url) {
    return url && !url.includes('http') ? 'https://' + url : url
  }

  static getProductUrl(newsSlug) {
    if (newsSlug) return `${newsSlug}`
    return '/products'
  }

  static getProductUrlForSearch(newsSlug) {
    if (newsSlug) return `/${newsSlug}`
    return '/products'
  }

  static getInvestorsUrl(newsSlug) {
    if (newsSlug) return `${newsSlug}`
    return '/investors'
  }

  static getMarketUrl(marketSlug) {
    const slugifiedMarket = marketSlug
      .toLowerCase()
      .replace('&', 'and')
      .replaceAll(' ', '-')
    if (marketSlug) return `/our-markets/${slugifiedMarket}`
    return '/our-markets'
  }

  static getPageUrl(location, page, tabName) {
    let params = new URLSearchParams(location.search)
    if (page) {
      params.set('page', page)
    }
    if (tabName) {
      params.set('tab', tabName)
    }
    return `?${params.toString()}`
  }

  static getLocationUrl(newsSlug) {
    if (newsSlug) return `/locations/${newsSlug}`
    return '/locations'
  }

  static getForeignProductUrl(locale, newsSlug) {
    if (newsSlug)
      return `/${LocalesRequestEnum[locale]}/${LocalesProductsEnum[locale]}/${newsSlug}`
    return '/products'
  }

  static getForeignLocationUrl(locale, newsSlug) {
    if (newsSlug)
      return `/${LocalesRequestEnum[locale]}/${LocalesLocationEnum[locale]}/${newsSlug}`
    return '/locations'
  }

  static getJobsUrl(id, title) {
    // Title slug need to be slice in order to match SEO acceptance
    const newSlug = slugifyFromNode(title).slice(0, 200)
    return `/careers/job-search/${id}/${newSlug}`
  }

  static getStoryUrl(slug) {
    return `${appRoute.story}/${slug}`
  }

  static getRightUrlForSearch(contentType, slug) {
    switch (contentType) {
      case ContentType.templateArticle:
        return this.getNewsUrl(slug)
      case ContentType.templateProduct:
        return this.getProductUrlForSearch(slug)
      case ContentType.templateLocation:
        return this.getLocationUrl(slug)
      case ContentType.pageContact:
        return appRoute.contact
      case ContentType.templatePageStory:
        return this.getStoryUrl(slug)
      default:
        return RoutingEnum.home + slug
    }
  }
}

export default UrlFactory
